export default __webpack_public_path__ + "f31d5db9a4a5f8c85d7744f6ef57f31c.png";